import axios from "axios";
import authHeader from "./auth-header";
import { config } from "../config";

class ChatService {
  getMessagesNotifications() {
    return axios
      .get(`${config.apiUrl}chats/unseenMessages`, { headers: authHeader() })
      .then((res) => res.data)
      .catch((err) => {
        if (err?.response?.status === 401) return [];
        console.error("Erro ao buscar mensagens:", err?.response?.data ?? err);
        return [];
      });
  }

  getMessagesNotificationsByPat(patId) {
    return axios
      .get(`${config.apiUrl}chats/unseenMessagesByPatId`, { params: { patId }, headers: authHeader() })
      .then((res) => res.data)
      .catch((err) => {
        if (err?.response?.status === 401) return [];
        console.error("Erro ao buscar mensagens:", err?.response?.data ?? err);
        return [];
      });
  }

  getPatsWithChats() {
    return axios
      .get(`${config.apiUrl}chats/patsWithChats`, { headers: authHeader() })
      .then((res) => {
        const payload = res?.data;
        if (Array.isArray(payload)) {
          return payload;
        }
        if (Array.isArray(payload?.data)) {
          return payload.data;
        }
        if (Array.isArray(payload?.data?.data)) {
          return payload.data.data;
        }
        return [];
      })
      .catch((err) => {
        if (err?.response?.status === 401) return [];
        console.error("Erro ao buscar PATs com chats:", err?.response?.data ?? err);
        return [];
      });
  }

  getMessages(patId) {
    return axios
      .get(`${config.apiUrl}chats`, { params: { patId }, headers: authHeader() })
      .then((res) => res.data)
      .catch((err) => {
        if (err?.response?.status === 401) return [];
        console.error("Erro ao buscar mensagens:", err?.response?.data ?? err);
        return [];
      });
  }

  markAsSeen(patId, sinceId) {
    return axios
      .get(`${config.apiUrl}chats/markAsSeen`, { params: { patId, sinceId }, headers: authHeader() })
      .then((res) => res.data)
      .catch((err) => {
        if (err?.response?.status === 401) return [];
        console.error("Erro ao marcar como vistas:", err?.response?.data ?? err);
        return [];
      });
  }

  newMessage(patId, message) {
    return axios
      .post(`${config.apiUrl}chats`, { patId, message }, { headers: authHeader() })
      .then((res) => {
        if (!res) {
          return null;
        }
        if (res.data && res.data.data !== undefined) {
          return res.data.data;
        }
        return res.data ?? null;
      })
      .catch((err) => {
        if (err?.response?.status === 401) throw err;
        console.error("Erro ao enviar mensagem:", err?.response?.data ?? err);
        throw err;
      });
  }

  openStream(patId, sinceId = null, options = {}) {
    const params = { patId };
    if (sinceId !== undefined && sinceId !== null) {
      params.sinceId = sinceId;
    }

    const { headers: optionHeaders, ...restOptions } = options || {};

    return axios
      .get(`${config.apiUrl}chats/stream`, {
        params,
        headers: {
          ...authHeader(),
          ...(optionHeaders || {}),
        },
        ...restOptions,
      })
      .then((response) => {
        if (response.status === 200) {
          return response.data;
        }
        return response.data ?? null;
      })
      .catch((error) => {
        if (error?.response?.status === 401) throw error;

        if (error?.code === "ERR_CANCELED" || error?.name === "CanceledError") {
          throw error;
        }

        console.log("ERROR:: ", error.response?.data ?? error);
        throw error;
      });
  }
}

export default new ChatService()
